module.exports = __webpack_public_path__ + "static/8_norsk-2421dfca9738eb3ba67ad560c7e230bb.png";